var map = {
	"./UNICEF-logo.png": 4076,
	"./abdullah-work/bigosoft-black.png": 1715,
	"./abdullah-work/bigosoft-logo-black-purple.webp": 3182,
	"./abdullah-work/bigosoft.png": 9841,
	"./abdullah-work/dubizzle-logo.png": 8243,
	"./abdullah-work/tradehat.svg": 4555,
	"./abdullah.heic": 2482,
	"./abdullah.jpg": 9701,
	"./acmnust.png": 2551,
	"./address_image.svg": 3906,
	"./afiniti-logo.png": 3854,
	"./afiniti-vector-logo.png": 8248,
	"./animated_logo.svg": 9083,
	"./aws-logo.png": 6199,
	"./awsblack.png": 8790,
	"./awseducate.png": 1842,
	"./blogs_image.svg": 7245,
	"./cloud_infrastructure.svg": 883,
	"./codeInLogo.png": 7873,
	"./contactMail.png": 3189,
	"./coursera_logo.png": 1170,
	"./data_science.svg": 8699,
	"./deeplearning_ai_logo.png": 9575,
	"./delhivery_logo.png": 201,
	"./developerActivity.svg": 9257,
	"./dsc_logo.png": 8750,
	"./dsc_logo.svg": 5460,
	"./dsclogo.png": 6547,
	"./dscnust-logo.png": 9646,
	"./dscnust-short.png": 6085,
	"./dscnust-vertical.png": 9957,
	"./education.svg": 1118,
	"./error.svg": 1054,
	"./experience.svg": 7480,
	"./feelingProud.svg": 8294,
	"./freecopy_logo.png": 4633,
	"./friendshome.png": 8718,
	"./fullstack.svg": 5137,
	"./gcp_logo.png": 1525,
	"./gdsc-itu.jpeg": 3023,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./grocerapp_logo.jpeg": 6476,
	"./haps-logo.svg": 2278,
	"./ibm_logo.png": 262,
	"./iiitk_logo.png": 6200,
	"./infinity-gif.svg": 253,
	"./intel_logo.jpg": 8504,
	"./jsFramework.svg": 9655,
	"./legato_logo.png": 1236,
	"./manOnTable.svg": 9854,
	"./mcn-logo.png": 9796,
	"./microsoft_logo.png": 752,
	"./mk.svg": 1584,
	"./moaz.jpg": 3647,
	"./mozilla_logo.png": 6816,
	"./muffito_logo.png": 9556,
	"./muhammad.jpg": 5356,
	"./nextuLogo.jpg": 8497,
	"./nptel_logo.png": 7439,
	"./nust-logo.png": 6750,
	"./portfolio.gif": 8467,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./pwa.png": 9180,
	"./quantaleap.png": 6538,
	"./qwiklabs-logo.png": 8028,
	"./romi-logo.png": 7805,
	"./saayaHealthLogo.png": 4176,
	"./shiftcrowd.png": 6753,
	"./srp-logo.png": 7721,
	"./stanford_logo.png": 6691,
	"./studentcodein-logo.jpg": 9875,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./ui_ux_design.svg": 9163,
	"./uol-logo.png": 3646,
	"./upwork.png": 4334,
	"./vyro.ai.png": 8854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;